// extracted by mini-css-extract-plugin
export default {"head":"History_head__sPboy","main_hero":"History_main_hero__t4Tb1","form":"History_form__9l7cM"};